import { css, CSSResult } from 'lit'
import { csTransition } from '@cloudsuite/mosaic-shared/styles/globals.style.js'


export const cscLightboxZoom = {
  transitionDuration: css`var(--csc-lightbox-zoom-transition-duration, ${csTransition.duration})`,
}

export const style: CSSResult = css`
  :host {
    display: block;
  }

  :host([hidden]) {
    display: none;
  }

  .csc-lightbox-zoom {
    position: relative;
    overflow: hidden;
    width: 100%;
    height: 100%;
    cursor: zoom-in;
    touch-action: none;
  }

  .csc-lightbox-zoom.zoomed {
    cursor: zoom-out;
  }

  .csc-lightbox-zoom cse-image {
    width: 100%;
    height: 100%;
    display: block;
    transition: none;
    transform-origin: 0 0;
  }
`
